// extracted by mini-css-extract-plugin
module.exports = {"ForumSearch__headline":"jy_a vh_no vh_oo vh_rb","ForumSearch__results--empty":"jy_b"};